/** @format */
import { FunctionComponent } from 'react';

import ATFlag from '@toucan/client/global/images/flag-at.svg';
import BEFlag from '@toucan/client/global/images/flag-be.svg';
import DEFlag from '@toucan/client/global/images/flag-de.svg';
import ESFlag from '@toucan/client/global/images/flag-es.svg';
import EUFlag from '@toucan/client/global/images/flag-eu.svg';
import FRFlag from '@toucan/client/global/images/flag-fr.svg';
import IEFlag from '@toucan/client/global/images/flag-ie.svg';
import ITFlag from '@toucan/client/global/images/flag-it.svg';
import NLFlag from '@toucan/client/global/images/flag-nl.svg';
import PTFlag from '@toucan/client/global/images/flag-pt.svg';
import UKFlag from '@toucan/client/global/images/flag-uk.svg';
import USFlag from '@toucan/client/global/images/flag-us.svg';

import { MarketCode } from '@toucan/client/global/market';

export const flags: Record<
    MarketCode,
    FunctionComponent<{ className?: string }>
> = {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment -- Legacy code: do not use as an example.
    [MarketCode.EN_UK]: UKFlag,
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment -- Legacy code: do not use as an example.
    [MarketCode.EN_US]: USFlag,
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment -- Legacy code: do not use as an example.
    [MarketCode.DE_DE]: DEFlag,
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment -- Legacy code: do not use as an example.
    [MarketCode.FR_FR]: FRFlag,
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment -- Legacy code: do not use as an example.
    [MarketCode.EN_EU]: EUFlag,
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment -- Legacy code: do not use as an example.
    [MarketCode.NL_NL]: NLFlag,
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment -- Legacy code: do not use as an example.
    [MarketCode.IT_IT]: ITFlag,
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment -- Legacy code: do not use as an example.
    [MarketCode.DE_AT]: ATFlag,
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment -- Legacy code: do not use as an example.
    [MarketCode.FR_BE]: BEFlag,
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment -- Legacy code: do not use as an example.
    [MarketCode.NL_BE]: BEFlag,
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment -- Legacy code: do not use as an example.
    [MarketCode.EN_IE]: IEFlag,
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment -- Legacy code: do not use as an example.
    [MarketCode.PT_PT]: PTFlag,
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment -- Legacy code: do not use as an example.
    [MarketCode.ES_ES]: ESFlag,
};
